// The wipe generation (Session ASB review, finding I6-6): a counter that moves every time this browser's offline copies
// of server data are wiped (offlineCache.clearOfflineApiCache: a sign-out, or somebody else signing in).
//
// WHY. A read that was already in flight when the wipe ran (the site-list sync or the job-list refresh, started when the
// app opened, answered a second after the engineer pressed Sign out on a slow basement link) would otherwise write its
// answer back into IndexedDB AFTER the wipe, leaving the job cards (door codes included) readable through the unguarded
// "Continue offline" view on a device nobody is signed in on. Each writer reads the generation when it STARTS and
// writes only if it is still the same when the answer lands; a late answer is simply dropped.
//
// In memory, per page: the wipe and the writers it guards against live in the same page, and a reload starts a fresh
// page with nothing in flight. No imports, so historyStore, jobsStore, timesheetStore and offlineCache can all use it.
let generation = 0;

export function wipeGeneration(): number {
  return generation;
}

// Called synchronously, as the very FIRST thing a wipe does, before anything it awaits.
export function bumpWipeGeneration(): void {
  generation += 1;
}
